// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"212":"component---src-pages-status-buy-order-js","351":"commons","678":"component---src-pages-index-js","792":"component---src-pages-status-index-js"}[chunkId] + "-" + {"212":"a2a79fa6578c172a69cc","351":"345ea5f751d197a24db0","678":"6a53330a2cbfb254b9f8","792":"bf9ee62554847f7da328"}[chunkId] + ".js";
};